module.exports = __webpack_public_path__ + "img/停用数据.a65c5940.svg";